"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSiblingWorkspace = exports.CREATE_SIBLING_WORKSPACE_RESULT = void 0;
const first_load_1 = __importDefault(require("@app/ac/first-load"));
const create_ac_1 = require("@app/ac/util/create-ac");
const workspace_switch_1 = __importDefault(require("@app/ac/workspace-switch"));
const expected_errors_1 = require("@app/request/auth/expected-errors");
const workspace_create_sibling_1 = require("@app/request/workspace/workspace-create-sibling");
const store_1 = __importDefault(require("@app/store"));
const util_1 = require("@app/util");
var CREATE_SIBLING_WORKSPACE_RESULT;
(function (CREATE_SIBLING_WORKSPACE_RESULT) {
    CREATE_SIBLING_WORKSPACE_RESULT["CREATED"] = "CREATED";
    CREATE_SIBLING_WORKSPACE_RESULT["NAME_EXISTS"] = "NAME_EXISTS";
    CREATE_SIBLING_WORKSPACE_RESULT["FAILED"] = "FAILED";
})(CREATE_SIBLING_WORKSPACE_RESULT || (exports.CREATE_SIBLING_WORKSPACE_RESULT = CREATE_SIBLING_WORKSPACE_RESULT = {}));
/**
 * Creates a workspace next to the selected one (same organization, area and settings,
 * the current user as its manager) and switches into it.
 */
exports.createSiblingWorkspace = (0, create_ac_1.createAC)(async (dispatch, { name }) => {
    const { workspaceId } = store_1.default.getState();
    if (!(0, util_1.isValue)(workspaceId))
        return CREATE_SIBLING_WORKSPACE_RESULT.FAILED;
    const expectedErrors = [workspace_create_sibling_1.WORKSPACE_CREATE_SIBLING_ERRORS.NAME_EXISTS];
    let nameExists = false;
    const created = await (0, workspace_create_sibling_1.requestWorkspaceCreateSibling)({ workspace: workspaceId, name, expectedErrors }, (errors) => {
        nameExists = errors?.some((error) => (0, expected_errors_1.matchesExpected)(error, expectedErrors)) ?? false;
    });
    if (nameExists)
        return CREATE_SIBLING_WORKSPACE_RESULT.NAME_EXISTS;
    if (!(0, util_1.isValue)(created))
        return CREATE_SIBLING_WORKSPACE_RESULT.FAILED;
    // workspaceSwitch only accepts workspaces that are already in store.workspaces,
    // which is built from me.acl - so reload `me` first
    await dispatch((0, first_load_1.default)(true, true));
    await dispatch((0, workspace_switch_1.default)(created));
    // '/' lands on whatever the app picks for this workspace (onboarding, dashboard, paywall, ...)
    util_1.routeUtil.navigate('/');
    return CREATE_SIBLING_WORKSPACE_RESULT.CREATED;
});
exports.default = exports.createSiblingWorkspace;
